/**
 * Created by mateimisarca on 2019-06-07
 */

import P404 from './404-page';

export default P404;
